var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSurfaceHabitableBlanc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.206,
    height: 32.37,
    viewBox: "0 0 32.206 32.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2845",
    "data-name": "Groupe 2845",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1928",
    "data-name": "Trac\\xE9 1928",
    className: "cls-1",
    d: "M6.83,3.4,6.022,1H1.788V5.357c3.773.68,3.773.68,5.042-1.561",
    transform: "translate(-0.94 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1929",
    "data-name": "Trac\\xE9 1929",
    className: "cls-1",
    d: "M37.018,32.907c3.069.608,1.766,3.022,2.052,4.993H34.194V33.707l2.42-.8",
    transform: "translate(-8.553 -7.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1930",
    "data-name": "Trac\\xE9 1930",
    className: "cls-1",
    d: "M36.639,6.178c3.627-.378,2.087-2.888,2.555-4.992H34.75c-1.561,2.447-1.014,4.043,1.485,4.992",
    transform: "translate(-8.577 -0.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1931",
    "data-name": "Trac\\xE9 1931",
    className: "cls-1",
    d: "M3.628,33.278c-3.1.372-1.616,2.807-2.165,4.594h4.8c.606-1.846,1.29-3.847-1.826-4.594",
    transform: "translate(-0.965 -7.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1932",
    "data-name": "Trac\\xE9 1932",
    className: "cls-2",
    d: "M3.849,6.194V17.777",
    transform: "translate(-0.782 0.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1933",
    "data-name": "Trac\\xE9 1933",
    className: "cls-2",
    d: "M18.139,3.226H6.846",
    transform: "translate(-3.118 -0.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1934",
    "data-name": "Trac\\xE9 1934",
    className: "cls-2",
    d: "M3.849,22.519V33.7",
    transform: "translate(-0.782 -8.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1935",
    "data-name": "Trac\\xE9 1935",
    className: "cls-2",
    d: "M36.442,6.194V17.377",
    transform: "translate(-8.381 0.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1936",
    "data-name": "Trac\\xE9 1936",
    className: "cls-2",
    d: "M18.139,35.875H6.846",
    transform: "translate(-3.118 -6.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1937",
    "data-name": "Trac\\xE9 1937",
    className: "cls-2",
    d: "M36.442,22.519V33.3",
    transform: "translate(-8.381 -8.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1938",
    "data-name": "Trac\\xE9 1938",
    className: "cls-2",
    d: "M23.33,35.5H34.219",
    transform: "translate(-10.02 -6.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1939",
    "data-name": "Trac\\xE9 1939",
    className: "cls-1",
    d: "M23.328,3.4,22.52,1H18.085V5.857c2.192-.313,4.629.979,5.243-2.062",
    transform: "translate(-4.913 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1940",
    "data-name": "Trac\\xE9 1940",
    className: "cls-1",
    d: "M23.328,35.676c-.589-2.827-2.779-2.484-5.243-2.308v4.505h4.84v-1.8",
    transform: "translate(-4.913 -7.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1941",
    "data-name": "Trac\\xE9 1941",
    className: "cls-1",
    d: "M3.663,17.324C-.269,17.566,2.6,20.257,1,22.118H6.168c-.462-1.651,2.505-4.405-1.7-4.794",
    transform: "translate(-1 -4.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1942",
    "data-name": "Trac\\xE9 1942",
    className: "cls-1",
    d: "M36.627,16.953c-3.627.379-2.087,2.89-2.6,5.193h5.244c-.583-2.19.918-4.461-2.241-5.193",
    transform: "translate(-8.566 -4.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1943",
    "data-name": "Trac\\xE9 1943",
    className: "cls-2",
    d: "M20.333,11.759V23.433",
    transform: "translate(-4.755 -1.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1944",
    "data-name": "Trac\\xE9 1944",
    className: "cls-2",
    d: "M23.435,19.551H12.84",
    transform: "translate(-2.468 -3.881)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSurfaceHabitableBlanc);
export default __webpack_public_path__ + "static/media/icon_surface_habitable_blanc.4006db8091f0944acbf2c6395a2771f9.svg";
export { ForwardRef as ReactComponent };